import Swiper from 'swiper/swiper-bundle';

export function mv() {
    // let mySwiper = new Swiper('.j-mvSlider', {
    //     spaceBetween: 30,
    //     effect: "fade",
    //     autoplay: {
    //     delay: 2500,
    //     disableOnInteraction: false,
    //     },
    // });
    // document.addEventListener("DOMContentLoaded", function () {
    const slides = document.querySelectorAll(".js-mask-slide");
    let current = 0;

    function showSlide(index) {
    slides.forEach((slide, i) => {
        if (i === index) {
        // 表示するスライド
        slide.classList.add("is-active");
        slide.classList.remove("is-active-again");
        } else {
        // 非表示にするスライド
        slide.classList.remove("is-active");

        // 再度アニメーションを発火させるために少し遅れてクラスを付け直す
        slide.classList.remove("is-active-again"); // 一度リセット（再トリガーのため）
        setTimeout(() => {
            slide.classList.add("is-active-again");
        }, 2000); // 2秒後に再アニメーション
        }
    });
    }

    function nextSlide() {
    current = (current + 1) % slides.length;
    showSlide(current);
    }

    showSlide(current);
    setInterval(nextSlide, 4000);

    // });

}